import { render, staticRenderFns } from "./StoreItemMultiDelete.vue?vue&type=template&id=72382389&"
import script from "./StoreItemMultiDelete.vue?vue&type=script&lang=js&"
export * from "./StoreItemMultiDelete.vue?vue&type=script&lang=js&"
import style0 from "./StoreItemMultiDelete.vue?vue&type=style&index=0&id=72382389&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports